import React from "react";

export const IconFacebook = () => (
  <svg width="23" height="22" viewBox="0 0 23 22" fill="none">
    <path
      d="M11.3028 22C17.5451 22 22.6055 17.0751 22.6055 11C22.6055 4.92487 17.5451 0 11.3028 0C5.06041 0 0 4.92487 0 11C0 17.0751 5.06041 22 11.3028 22Z"
      fill="#FAFBFB"
    />
    <path
      d="M14.1449 11.4303H12.1281V18.6211H9.07243V11.4303H7.61914V8.90314H9.07243V7.26779C9.07243 6.09833 9.64323 4.26709 12.1553 4.26709L14.4188 4.27631V6.72933H12.7765C12.5071 6.72933 12.1283 6.86032 12.1283 7.41818V8.90549H14.4119L14.1449 11.4303Z"
      fill="#3B5998"
    />
  </svg>
);
